// Comprehensive Exercise Catalog - Based on wger.de open database + RP-style additions
// Organized by muscle group for hypertrophy training

export const exerciseCatalog = {
  Chest: [
    // Barbell
    { name: 'Bench Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Incline Bench Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Decline Bench Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Close Grip Bench Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Floor Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Paused Bench Press', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Dumbbell Bench Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Incline Dumbbell Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Decline Dumbbell Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell Flyes', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Incline Dumbbell Flyes', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Dumbbell Pullover', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Crush Press', equipment: 'Dumbbell', type: 'compound' },
    // Cable
    { name: 'Cable Crossover', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Fly (Low to High)', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Fly (High to Low)', equipment: 'Cable', type: 'isolation' },
    { name: 'Single Arm Cable Fly', equipment: 'Cable', type: 'isolation' },
    // Machine
    { name: 'Machine Chest Press', equipment: 'Machine', type: 'compound' },
    { name: 'Incline Machine Press', equipment: 'Machine', type: 'compound' },
    { name: 'Pec Deck Fly', equipment: 'Machine', type: 'isolation' },
    { name: 'Smith Machine Bench Press', equipment: 'Smith Machine', type: 'compound' },
    { name: 'Smith Machine Incline Press', equipment: 'Smith Machine', type: 'compound' },
    // Bodyweight
    { name: 'Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Incline Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Decline Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Diamond Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Wide Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Chest Dips', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Weighted Dips', equipment: 'Bodyweight', type: 'compound' },
  ],

  Back: [
    // Barbell
    { name: 'Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Conventional Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Sumo Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Barbell Row', equipment: 'Barbell', type: 'compound' },
    { name: 'Pendlay Row', equipment: 'Barbell', type: 'compound' },
    { name: 'T-Bar Row', equipment: 'Barbell', type: 'compound' },
    { name: 'Rack Pulls', equipment: 'Barbell', type: 'compound' },
    { name: 'Bent Over Row (Underhand)', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Dumbbell Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Single Arm Dumbbell Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Chest Supported Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Kroc Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell Pullover', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Seal Row', equipment: 'Dumbbell', type: 'compound' },
    // Cable
    { name: 'Lat Pulldown (Wide)', equipment: 'Cable', type: 'compound' },
    { name: 'Lat Pulldown (Close)', equipment: 'Cable', type: 'compound' },
    { name: 'Lat Pulldown (Neutral)', equipment: 'Cable', type: 'compound' },
    { name: 'Lat Pulldown (Underhand)', equipment: 'Cable', type: 'compound' },
    { name: 'Seated Cable Row', equipment: 'Cable', type: 'compound' },
    { name: 'Seated Cable Row (Wide)', equipment: 'Cable', type: 'compound' },
    { name: 'Face Pulls', equipment: 'Cable', type: 'isolation' },
    { name: 'Straight Arm Pulldown', equipment: 'Cable', type: 'isolation' },
    { name: 'Single Arm Lat Pulldown', equipment: 'Cable', type: 'compound' },
    { name: 'Cable Row (Standing)', equipment: 'Cable', type: 'compound' },
    // Machine
    { name: 'Machine Row', equipment: 'Machine', type: 'compound' },
    { name: 'Hammer Strength Row', equipment: 'Machine', type: 'compound' },
    { name: 'Hammer Strength Pulldown', equipment: 'Machine', type: 'compound' },
    { name: 'Chest Supported Machine Row', equipment: 'Machine', type: 'compound' },
    // Bodyweight
    { name: 'Pull-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Chin-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Neutral Grip Pull-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Wide Grip Pull-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Weighted Pull-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Inverted Rows', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Hyperextensions', equipment: 'Bodyweight', type: 'isolation' },
  ],

  Shoulders: [
    // Barbell
    { name: 'Overhead Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Military Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Push Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Behind Neck Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Upright Row', equipment: 'Barbell', type: 'compound' },
    { name: 'Barbell Front Raise', equipment: 'Barbell', type: 'isolation' },
    // Dumbbell
    { name: 'Seated Dumbbell Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Standing Dumbbell Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Arnold Press', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Lateral Raises', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Front Raises', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Rear Delt Flyes', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Incline Rear Delt Flyes', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Dumbbell Upright Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Lu Raises', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Y Raises', equipment: 'Dumbbell', type: 'isolation' },
    // Cable
    { name: 'Cable Lateral Raises', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Front Raises', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Rear Delt Fly', equipment: 'Cable', type: 'isolation' },
    { name: 'Face Pulls', equipment: 'Cable', type: 'compound' },
    { name: 'Cable Upright Row', equipment: 'Cable', type: 'compound' },
    // Machine
    { name: 'Machine Shoulder Press', equipment: 'Machine', type: 'compound' },
    { name: 'Smith Machine Press', equipment: 'Smith Machine', type: 'compound' },
    { name: 'Machine Lateral Raise', equipment: 'Machine', type: 'isolation' },
    { name: 'Reverse Pec Deck', equipment: 'Machine', type: 'isolation' },
    // Bodyweight
    { name: 'Handstand Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Pike Push-Ups', equipment: 'Bodyweight', type: 'compound' },
  ],

  Biceps: [
    // Barbell
    { name: 'Barbell Curl', equipment: 'Barbell', type: 'isolation' },
    { name: 'EZ Bar Curl', equipment: 'EZ Bar', type: 'isolation' },
    { name: 'Preacher Curl', equipment: 'EZ Bar', type: 'isolation' },
    { name: 'Reverse Curl', equipment: 'Barbell', type: 'isolation' },
    { name: 'Drag Curl', equipment: 'Barbell', type: 'isolation' },
    { name: 'Wide Grip Curl', equipment: 'Barbell', type: 'isolation' },
    { name: 'Close Grip Curl', equipment: 'Barbell', type: 'isolation' },
    // Dumbbell
    { name: 'Dumbbell Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Alternating Dumbbell Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Hammer Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Incline Dumbbell Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Concentration Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Spider Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Zottman Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Cross Body Curl', equipment: 'Dumbbell', type: 'isolation' },
    // Cable
    { name: 'Cable Curl', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Hammer Curl', equipment: 'Cable', type: 'isolation' },
    { name: 'High Cable Curl', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Preacher Curl', equipment: 'Cable', type: 'isolation' },
    { name: 'Bayesian Curl', equipment: 'Cable', type: 'isolation' },
    // Machine
    { name: 'Machine Preacher Curl', equipment: 'Machine', type: 'isolation' },
    { name: 'Machine Curl', equipment: 'Machine', type: 'isolation' },
  ],

  Triceps: [
    // Barbell
    { name: 'Close Grip Bench Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Skull Crushers', equipment: 'EZ Bar', type: 'isolation' },
    { name: 'JM Press', equipment: 'Barbell', type: 'compound' },
    { name: 'Lying Tricep Extension', equipment: 'Barbell', type: 'isolation' },
    // Dumbbell
    { name: 'Overhead Tricep Extension', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Dumbbell Skull Crushers', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Tricep Kickbacks', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Tate Press', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'PJR Pullover', equipment: 'Dumbbell', type: 'isolation' },
    // Cable
    { name: 'Tricep Pushdown', equipment: 'Cable', type: 'isolation' },
    { name: 'Rope Pushdown', equipment: 'Cable', type: 'isolation' },
    { name: 'Overhead Cable Extension', equipment: 'Cable', type: 'isolation' },
    { name: 'Single Arm Pushdown', equipment: 'Cable', type: 'isolation' },
    { name: 'Reverse Grip Pushdown', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Kickbacks', equipment: 'Cable', type: 'isolation' },
    // Machine
    { name: 'Machine Tricep Extension', equipment: 'Machine', type: 'isolation' },
    { name: 'Assisted Dips', equipment: 'Machine', type: 'compound' },
    // Bodyweight
    { name: 'Tricep Dips', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Bench Dips', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Diamond Push-Ups', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Close Grip Push-Ups', equipment: 'Bodyweight', type: 'compound' },
  ],

  Quads: [
    // Barbell
    { name: 'Back Squat', equipment: 'Barbell', type: 'compound' },
    { name: 'Front Squat', equipment: 'Barbell', type: 'compound' },
    { name: 'High Bar Squat', equipment: 'Barbell', type: 'compound' },
    { name: 'Low Bar Squat', equipment: 'Barbell', type: 'compound' },
    { name: 'Pause Squat', equipment: 'Barbell', type: 'compound' },
    { name: 'Hack Squat (Barbell)', equipment: 'Barbell', type: 'compound' },
    { name: 'Zercher Squat', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Goblet Squat', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell Lunges', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Walking Lunges', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Reverse Lunges', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Bulgarian Split Squat', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Step-Ups', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell Squat', equipment: 'Dumbbell', type: 'compound' },
    // Machine
    { name: 'Leg Press', equipment: 'Machine', type: 'compound' },
    { name: 'Hack Squat Machine', equipment: 'Machine', type: 'compound' },
    { name: 'Leg Extension', equipment: 'Machine', type: 'isolation' },
    { name: 'Pendulum Squat', equipment: 'Machine', type: 'compound' },
    { name: 'V-Squat', equipment: 'Machine', type: 'compound' },
    { name: 'Smith Machine Squat', equipment: 'Smith Machine', type: 'compound' },
    // Bodyweight
    { name: 'Bodyweight Squat', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Pistol Squat', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Sissy Squat', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Jump Squat', equipment: 'Bodyweight', type: 'compound' },
  ],

  Hamstrings: [
    // Barbell
    { name: 'Romanian Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Stiff Leg Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Good Mornings', equipment: 'Barbell', type: 'compound' },
    { name: 'Snatch Grip RDL', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Dumbbell RDL', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Single Leg RDL', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell Good Morning', equipment: 'Dumbbell', type: 'compound' },
    // Machine
    { name: 'Lying Leg Curl', equipment: 'Machine', type: 'isolation' },
    { name: 'Seated Leg Curl', equipment: 'Machine', type: 'isolation' },
    { name: 'Standing Leg Curl', equipment: 'Machine', type: 'isolation' },
    { name: 'Glute Ham Raise', equipment: 'Machine', type: 'compound' },
    // Cable
    { name: 'Cable Pull Through', equipment: 'Cable', type: 'compound' },
    // Bodyweight
    { name: 'Nordic Curl', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Slider Leg Curl', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Swiss Ball Leg Curl', equipment: 'Swiss Ball', type: 'isolation' },
  ],

  Glutes: [
    // Barbell
    { name: 'Hip Thrust', equipment: 'Barbell', type: 'compound' },
    { name: 'Sumo Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Romanian Deadlift', equipment: 'Barbell', type: 'compound' },
    { name: 'Good Mornings', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Dumbbell Hip Thrust', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Sumo Squat', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Dumbbell RDL', equipment: 'Dumbbell', type: 'compound' },
    // Machine
    { name: 'Hip Thrust Machine', equipment: 'Machine', type: 'compound' },
    { name: 'Glute Kickback Machine', equipment: 'Machine', type: 'isolation' },
    { name: 'Hip Abduction Machine', equipment: 'Machine', type: 'isolation' },
    { name: 'Reverse Hyperextension', equipment: 'Machine', type: 'isolation' },
    // Cable
    { name: 'Cable Kickback', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Pull Through', equipment: 'Cable', type: 'compound' },
    { name: 'Cable Hip Abduction', equipment: 'Cable', type: 'isolation' },
    // Bodyweight
    { name: 'Glute Bridge', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Single Leg Glute Bridge', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Frog Pumps', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Donkey Kicks', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Fire Hydrants', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Clamshells', equipment: 'Bodyweight', type: 'isolation' },
  ],

  Calves: [
    // Machine
    { name: 'Standing Calf Raise', equipment: 'Machine', type: 'isolation' },
    { name: 'Seated Calf Raise', equipment: 'Machine', type: 'isolation' },
    { name: 'Leg Press Calf Raise', equipment: 'Machine', type: 'isolation' },
    { name: 'Donkey Calf Raise', equipment: 'Machine', type: 'isolation' },
    { name: 'Hack Squat Calf Raise', equipment: 'Machine', type: 'isolation' },
    // Smith Machine
    { name: 'Smith Machine Calf Raise', equipment: 'Smith Machine', type: 'isolation' },
    // Dumbbell
    { name: 'Dumbbell Calf Raise', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Single Leg Dumbbell Calf Raise', equipment: 'Dumbbell', type: 'isolation' },
    // Bodyweight
    { name: 'Bodyweight Calf Raise', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Single Leg Calf Raise', equipment: 'Bodyweight', type: 'isolation' },
    // Tibialis
    { name: 'Tibialis Raise', equipment: 'Machine', type: 'isolation' },
  ],

  Traps: [
    // Barbell
    { name: 'Barbell Shrugs', equipment: 'Barbell', type: 'isolation' },
    { name: 'Behind Back Shrugs', equipment: 'Barbell', type: 'isolation' },
    { name: 'Upright Row', equipment: 'Barbell', type: 'compound' },
    { name: 'Rack Pulls', equipment: 'Barbell', type: 'compound' },
    { name: 'Snatch Grip High Pull', equipment: 'Barbell', type: 'compound' },
    // Dumbbell
    { name: 'Dumbbell Shrugs', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Dumbbell Upright Row', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Farmer Walks', equipment: 'Dumbbell', type: 'compound' },
    // Cable
    { name: 'Cable Shrugs', equipment: 'Cable', type: 'isolation' },
    { name: 'Face Pulls', equipment: 'Cable', type: 'compound' },
    { name: 'Cable Upright Row', equipment: 'Cable', type: 'compound' },
    // Machine
    { name: 'Smith Machine Shrugs', equipment: 'Smith Machine', type: 'isolation' },
    { name: 'Trap Bar Shrugs', equipment: 'Trap Bar', type: 'isolation' },
  ],

  Forearms: [
    // Barbell
    { name: 'Wrist Curls', equipment: 'Barbell', type: 'isolation' },
    { name: 'Reverse Wrist Curls', equipment: 'Barbell', type: 'isolation' },
    { name: 'Reverse Curl', equipment: 'Barbell', type: 'isolation' },
    { name: 'Behind Back Wrist Curl', equipment: 'Barbell', type: 'isolation' },
    // Dumbbell
    { name: 'Dumbbell Wrist Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Dumbbell Reverse Curl', equipment: 'Dumbbell', type: 'isolation' },
    { name: 'Hammer Curl', equipment: 'Dumbbell', type: 'compound' },
    { name: 'Farmer Walks', equipment: 'Dumbbell', type: 'compound' },
    // Cable
    { name: 'Cable Wrist Curl', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Reverse Curl', equipment: 'Cable', type: 'isolation' },
    // Grip
    { name: 'Plate Pinch', equipment: 'Plates', type: 'isolation' },
    { name: 'Dead Hang', equipment: 'Pull-up Bar', type: 'isolation' },
    { name: 'Wrist Roller', equipment: 'Cable', type: 'isolation' },
    { name: 'Gripper Squeeze', equipment: 'Gripper', type: 'isolation' },
  ],

  Abs: [
    // Bodyweight
    { name: 'Crunches', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Sit-Ups', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Plank', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Side Plank', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Leg Raises', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Hanging Leg Raise', equipment: 'Pull-up Bar', type: 'isolation' },
    { name: 'Hanging Knee Raise', equipment: 'Pull-up Bar', type: 'isolation' },
    { name: 'V-Ups', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Bicycle Crunch', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Russian Twist', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Mountain Climbers', equipment: 'Bodyweight', type: 'compound' },
    { name: 'Dead Bug', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Bird Dog', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Hollow Body Hold', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Toe Touches', equipment: 'Bodyweight', type: 'isolation' },
    { name: 'Flutter Kicks', equipment: 'Bodyweight', type: 'isolation' },
    // Machine/Cable
    { name: 'Cable Crunch', equipment: 'Cable', type: 'isolation' },
    { name: 'Cable Woodchop', equipment: 'Cable', type: 'compound' },
    { name: 'Machine Crunch', equipment: 'Machine', type: 'isolation' },
    { name: 'Decline Crunch', equipment: 'Bench', type: 'isolation' },
    { name: 'Ab Wheel Rollout', equipment: 'Ab Wheel', type: 'compound' },
    { name: 'Pallof Press', equipment: 'Cable', type: 'isolation' },
    // Weighted
    { name: 'Weighted Plank', equipment: 'Plate', type: 'isolation' },
    { name: 'Weighted Sit-Up', equipment: 'Plate', type: 'isolation' },
  ],
};

export const getExercisesForMuscle = (muscle) => {
  return exerciseCatalog[muscle] || [];
};

export const getAllMuscleGroups = () => {
  return Object.keys(exerciseCatalog);
};

export const getTotalExerciseCount = () => {
  return Object.values(exerciseCatalog).reduce((total, exercises) => total + exercises.length, 0);
};
